import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Guide } from '@r1-frontend/ui-react/components/Guide';
import HtmlContentFromApi from '@r1-frontend/ui-react/components/HtmlContentFromApi';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import OpenChat from '~/src/components/OpenChatLink';
import { BasePopupRightAlign, TheScrollbar } from '~/src/features/full-buy/popups/BasePopupRightAlign';
import { getGuideData } from '~/src/features/full-buy/store/selectors/getGuideData/getGuideData';

interface IGuideFullBuy {
    isOpen: boolean,
    onClose: () => void,
}

export const GuideFullBuy = ({ isOpen, onClose }: IGuideFullBuy): JSX.Element => {
    const guideData = useSelector(getGuideData);

    const createDescriptionElements = useMemo(()=>{
        return guideData?.map((item)=> {
            if (item?.info) {
                return { ...item, info: <HtmlContentFromApi>{item.info}</HtmlContentFromApi> };
            } else {
                return item;
            }
        });
    }, [guideData]);

    if (!createDescriptionElements) {
        return <></>;
    }

    return (
        <BasePopupRightAlign
            isOpen={isOpen}
            onClose={onClose}
            dPadding={32}
            mPadding={24}
        >
                <H3>Подключение тарифа: шаги</H3>
                <TheScrollbar>
                        <Paragraph4
                            $color={COLORS.TextSecondary}
                            $withIndent={true}
                        >
                            Если на&nbsp;каком-либо шаге появятся сложности, <OpenChat>напишите в чат.</OpenChat> Поможем разобраться.
                        </Paragraph4>
                        <Guide items={createDescriptionElements}/>
                </TheScrollbar>
        </BasePopupRightAlign>
    );
};
